import { getData, putData, postData, deleteData } from '../apiClient';

// get subscribe email list with pagination and search
export const getSubscribeEmailList = async ({ page = 1, limit = 10, search = '' }) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search: search
    });

    const result = await getData(`/subscribe-emaillist/get?${queryParams}`);
    return {
      success: true,
      ...result
    };
  } catch (error) {
    console.error('Get subscribe email list API error:', error);
    return {
      data: {
        success: false,
        error: error.message,
        data: [],
        totalPages: 1,
        prevPage: false,
        nextPage: false,
        totalDocs: 0,
        page: 1
      }
    };
  }
};

/**
 * Updates the status of a subscriber.
 * 
 * @param {Object} data - Payload containing emailid and new status.
 */
export const updateSubscribeEmailStatus = async ({ data }) => {
  try {
    const result = await putData("/subscribe-emaillist/update-status", data);
    return {
      success: true,
      data: result,
    };
  } catch (error) {
    console.error("Update member Status API error:", error);
    return {
      success: false,
      error: error.status === 400 ? error.error : error.message,
      status: error.status,
    };
  }
};


const API_URL = "subscribe-emaillist";
const ItemName = "Member";

export const Create = async ({ data }) => {
  try {
    const result = await postData(
      `/${API_URL}/create`,
      data
    );


    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(
      `Create ${ItemName} API error:`,
      error.status === 400 ? error.error : error.message
    );

    return {
      data: {
        success: false,
        error:
          error.status === 400
            ? error.data.error
            : error.message,
        status: error.status,
      },
    };
  }
};

// delete item
export const Delete = async ({ id }) => {
  try {
    const result = await deleteData(`/${API_URL}/${id}`);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Delete ${ItemName} API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};


export const GetById = async (id, signal = null) => {
  try {
    const result = await getData(`/${API_URL}/${id}`, {}, {}, signal);
    return { success: true, ...result };
  } catch (error) {
    console.error(`Get ${ItemName} by id API error:`, error);
    return { success: false, ...error };
  }
};

export const Update = async ({ id, data }, signal = null) => {
  try {
    const result = await putData(`/${API_URL}/update/${id}`, data, {}, signal);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Update ${ItemName} API error:`, error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.error : error.message,
        status: error.status,
      },
    };
  }
};
